export default "__VITE_ASSET__cSfOy3eB__"